import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowCreatePatientOrderConfigSchema = z.object({
    payload: z.string(),
});
export const FlowCreatePatientOrderBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.CreatePatientOrder),
    config: FlowCreatePatientOrderConfigSchema,
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.PatientOrder),
});
//# sourceMappingURL=config.js.map